import { render, staticRenderFns } from "./VerifyRecordDetail.vue?vue&type=template&id=212e4d57&scoped=true&"
import script from "./VerifyRecordDetail.vue?vue&type=script&lang=js&"
export * from "./VerifyRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./VerifyRecordDetail.vue?vue&type=style&index=0&id=212e4d57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212e4d57",
  null
  
)

export default component.exports